import {
  REQUEST_LOGIN, SUCCESS_LOGIN, FAILED_LOGIN,
  LOGOUT, SET_REDIRECT, VERIFY, FAILED_VARIFICATION
} from '../actions/auth';

export default function auth(state = {
  loading: false,
  loaded: false,
  user: null,
  redirect: null,
  verify: false,
}, action) {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        user: null,
        loaded: false,
        verify: false,
        redirect: action.payload.redirect ? state.redirect : null,
      }
    case REQUEST_LOGIN:
      return {
        ...state,
        loading: true
      };
    case SUCCESS_LOGIN:
      return {
        ...state,
        loading: false,
        loaded: true,
        verify: false,
        user: action.payload.user,
        lastUpdated: action.payload.receivedAt,
      };
    case FAILED_LOGIN:
      return {
        ...state,
        loading: false,
        verify: false
      };
    case SET_REDIRECT:
      return {
        ...state,
        redirect: action.payload.redirect,
      };
    case VERIFY:
      return {
        ...state,
        verify: true
      };
    case FAILED_VARIFICATION:
      return {
        ...state,
        loading: false,
        verify: true
    };
    default:
      return state;
  }
}
